import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marks an HTTP request as "silent" — interceptors that surface user-facing
 * errors (toasts, alerts) must skip when this flag is `true`.
 *
 * Use for fire-and-forget calls (analytics, telemetry, statistics) where
 * failures must not interrupt the user.
 */
export const SILENT_REQUEST = new HttpContextToken<boolean>(() => false);

export function silentHttpContext(): HttpContext {
  return new HttpContext().set(SILENT_REQUEST, true);
}
